if (!customElements.get('diamond-actions')) {
  window.DiamondActions = class DiamondActions extends HTMLElement {
    constructor() {
      super();
      this.moreInfoBtn = this.querySelector('[data-action="more-info"]');
      this.certNumber = this.dataset.certNumber;
      this.diamondType = this.dataset.diamondType;
      this.title = this.dataset.title;
      this.diamondUrl = this.dataset.diamondUrl;
      this.handle = this.dataset.handle;
      this.submitBtn = this.querySelector('[data-action="select"]');

      // Add request state management
      this.diamondProduct = null;
      this.isRequestInProgress = false;

      const submitDiamondLink = document.querySelector('.journey-tracker__step-link[data-action="submit-diamond"]');
      if (submitDiamondLink && window.theme.template == 'product') {
        submitDiamondLink.addEventListener('click', this.submit.bind(this));
      }

      const tracker = document.querySelector('[data-journey-start-with]');
      if (tracker && tracker.dataset.currentStep.includes('diamond')) {
        window.journey_start_with = window.journey_start_with || 'diamond';
        const startWith = tracker.dataset.journeyStartWith;
        if (startWith) window.journey_start_with = startWith;
      }

      if (this.moreInfoBtn) this.moreInfoBtn.addEventListener('click', this.moreInfoHandler.bind(this));
      if (this.submitBtn) this.submitBtn.addEventListener('click', this.submit.bind(this));

      // Add pageshow event listener to handle page load from cache
      window.addEventListener('pageshow', this.handlePageShow.bind(this));
    }

    connectedCallback() {
      const card = this.closest('.diamond-card');
      if (!document.location.href.includes('products/') && card && this.querySelector('[data-action="select"]')) {
        card.addEventListener('mouseover', this.fetchLatestDiamonds.bind(this), {
          once: true,
        });
      }
    }

    async fetchLatestDiamonds() {
      // Check if request is already in progress or data already exists
      if (this.isRequestInProgress || this.diamondProduct) {
        console.log('Request already in progress or data already available');
        return this.diamondProduct;
      }

      console.log('fetchLatestDiamonds');
      this.isRequestInProgress = true;

      try {
        this.diamondProduct = await DiamondActions.fetchDiamondProduct({
          certNumber: this.certNumber,
          diamondType: this.diamondType,
          handle: this.dataset.handle,
        });
        return this.diamondProduct;
      } catch (error) {
        console.error('Failed to fetch diamond product:', error);
        // Reset on error so retry is possible
        this.diamondProduct = null;
        throw error;
      } finally {
        this.isRequestInProgress = false;
      }
    }

    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    moreInfoHandler(evt) {
      evt.preventDefault();
      DiamondActions.showOverlay();
      const handle = this.dataset.handle;
      // Use cached data if available, otherwise create new request
      if (this.diamondProduct) {
        DiamondActions.checkAndRedirect({ url: `${theme.routes.root_url}products/${handle}`, direct: true });
      } else {
        DiamondActions.createDiamondProduct({ certNumber: this.certNumber, diamondType: this.diamondType, redirect: true, handle }); // it will redirect to the product page
      }
    }

    async submit(event) {
      if (event?.preventDefault) event.preventDefault();
      if (window.__diamondUnavailable) return; // diamond-availability.js flagged this stone as sold

      let diamond = {
        handle: this.handle,
        shape: this.dataset.shape,
        timestamp: Date.now(),
      };

      const shape = this.dataset.shape;
      const type = this.dataset.type;
      const certNumber = this.dataset.certNumber;
      DiamondActions.showOverlay();
      await DiamondActions.selectHandler({ diamond, shape, type, certNumber });
    }

    static async selectHandler({ diamond, shape: shape_, type, certNumber }) {
      //const shape = this.capitalize(shape_).split(' ')[0];
      //const ringsCollectionUrl = `${window.theme.rings_collection_url}?&filter.p.m.custom.ring_shape=${shape}&type=${type.toLowerCase()}&view=diamonds-journey-rings`;
      const shape = (shape_ ? shape_ : 'round').replaceAll(' ', '_').toLowerCase().trim();
      const shapeCollectionUrl = window[`${shape}_collection_url`]; /* + '?view=diamonds-journey-rings' */
      if (!window[`${shape}_collection_url`]) {
        return alert(`make sure that collection for ${shape} is active`);
      }

      let attributes = Object.fromEntries(Object.entries(diamond).map(([key, value]) => [`diamond_${key}`, value])); // { diamond_handle: diamond.handle, diamond_shape: diamond.shape, diamond_timestamp: diamond.timestamp }

      if (window.journey_start_with == 'diamond') {
        attributes.rings_collection_url = shapeCollectionUrl;
      }
      if (window.journey_start_with == 'setting') {
        attributes = DiamondActions.validateAndUpdateRingShape(attributes);
      }

      try {
        const promises = [DiamondActions.updateCartAttrs({ attributes })];
        /// labgrown-diamond-certnumber, extract cert number from the handle
        if (!window.location.href.includes('products/'))
          promises.push(DiamondActions.createDiamondProduct({ certNumber: certNumber, redirect: false, handle: attributes.diamond_handle }));

        const [cartData, diamondData] = await Promise.all(promises);
        console.log('cartData', cartData);
        console.log('diamondData', diamondData);

        if (diamondData && diamondData.available === false) {
          // Stone sold at Nivoda since the search results were loaded: undo the selection we just stored.
          await DiamondActions.updateCartAttrs({ attributes: { diamond_handle: '', diamond_shape: '', diamond_timestamp: '' } }).catch(() => {});
          DiamondActions.hideOverlay();
          alert('Sorry, this diamond is no longer available. Please choose another diamond.');
          return;
        }

        // wait for 200ms to make sure product is created and fetchable
        if (!diamondData) await DiamondActions.checkAndRedirect({ url: `${theme.routes.root_url}products/${attributes.diamond_handle}`, direct: false });

        const ring_shape_down = cartData.attributes.ring_shape?.toLowerCase().replaceAll(' ', '_');
        const diamond_shape_down = cartData.attributes.diamond_shape?.toLowerCase().replaceAll(' ', '_');
        //debugger;
        if (ring_shape_down == diamond_shape_down && cartData.attributes.diamond_handle) {
          return (window.location.href = window.complete_engagement_ring_url);
        }
        if (!cartData.attributes.ring_handle && window.journey_start_with == 'diamond') {
          window.location.href = shapeCollectionUrl;
        } else {
          window.location.href = window.complete_engagement_ring_url;
        }
      } catch (error) {
        console.error('Cart update failed:', error);
      }
    }

    static async createDiamondProduct({ certNumber, diamondType, redirect = true, handle }) {
      const url = window.diamonds_route + `/products/check/${handle}`;
      const instance = document.querySelector(`diamond-actions[data-cert-number="${certNumber}"]`);
      const data = await instance.fetchLatestDiamonds();
      if (redirect) {
        DiamondActions.checkAndRedirect({ url: `${theme.routes.root_url}products/${handle}` });
        //window.location.href = `${theme.routes.root_url}products/${handle}`;
      } else {
        return data;
      }
    }

    static async fetchDiamondProduct({ certNumber, diamondType, handle }) {
      handle = handle || `${diamondType}-diamond-${certNumber}`;
      const url = window.diamonds_route + `/products/check/${handle}`;
      return fetch(url)
        .then((response) => (response.status === 404 ? { available: false } : response.json()))
        .then((data) => {
          console.log('data', data);
          return data;
        })
        .catch((error) => {
          console.error('Product check failed', error);
          //alert('An error occurred while trying to view the product. Please try again.');
        });
    }

    static async updateCartAttrs({ attributes }) {
      const maxRetries = 3;
      let retryCount = 0;
      let lastError = null;
      if (!window.theme.journey_started_at) {
        attributes.journey_started_at = window.theme.server_time;
      }

      while (retryCount < maxRetries) {
        try {
          const response = await fetch(`${theme.routes.cart_update_url}.js`, {
            method: 'POST',
            body: JSON.stringify({
              attributes,
            }),
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          return await response.json();
        } catch (error) {
          lastError = error;
          console.warn(`Cart update attempt ${retryCount + 1} failed:`, error.message);
          retryCount++;

          if (retryCount < maxRetries) {
            // Wait with exponential backoff before retrying (300ms, 600ms, 1200ms)
            await new Promise((resolve) => setTimeout(resolve, 300 * Math.pow(2, retryCount - 1)));
          }
        }
      }

      // All retries failed
      console.error(`Cart update failed after ${maxRetries} attempts:`, lastError);
      throw new Error(lastError.message || 'Failed to update cart after multiple attempts');
    }

    static validateAndUpdateRingShape(attributes) {
      const ring_available_shapes = DiamondActions.toHandle(window.ring_available_shapes).split(',');
      const diamond_shape = attributes.diamond_shape;
      const diamond_shape_down = DiamondActions.toHandle(diamond_shape);
      if (DiamondActions.toHandle(window.ring_shape) === diamond_shape_down) {
        return attributes;
      }
      // if the diamond shape is in the ring available shapes, then we need to update the ring shape
      if (ring_available_shapes.includes(diamond_shape_down)) {
        const ring_product_json = document.getElementById('ring-product-json');
        if (ring_product_json) {
          const ring_product = JSON.parse(ring_product_json.textContent);
          const ring_variants = ring_product.variants;
          const selectedVariant = ring_variants.find((variant) => variant.id == window.ring_variant_id);
          const newVariant =
            ring_variants.find(
              (variant) =>
                DiamondActions.toHandle(variant.option1) == DiamondActions.toHandle(diamond_shape) &&
                variant.option2 == selectedVariant.option2 &&
                variant.option3 == selectedVariant.option3 &&
                variant.available
            ) ||
            ring_variants.find(
              (variant) => DiamondActions.toHandle(variant.option1) == DiamondActions.toHandle(diamond_shape) && variant.option2 == selectedVariant.option2 && variant.available
            );
          if (newVariant) {
            attributes.ring_variant_id = newVariant.id;
            attributes.ring_shape = diamond_shape_down.toUpperCase();
          } else {
            console.error('No variant found for the diamond shape', diamond_shape_down);
          }
        }
      }
      return attributes;
    }

    static toHandle(text) {
      return text.toLowerCase().replaceAll(' ', '_');
    }

    static showOverlay({ msg = 'Preparing your diamond ...' } = {}) {
      const overlay = document.querySelector('.prepparing-diamonds__loading-wrapper');
      const msgEl = overlay.querySelector('.prepparing-diamonds__msg');
      if (msgEl) {
        msgEl.textContent = msg;
      }
      if (overlay) {
        overlay.style.display = 'block';
      }
    }

    static hideOverlay() {
      const overlay = document.querySelector('.prepparing-diamonds__loading-wrapper');
      const msgEl = overlay?.querySelector('.prepparing-diamonds__msg');
      if (msgEl) {
        msgEl.textContent = '';
      }
      if (overlay) {
        overlay.style.display = 'none';
      }
    }

    disconnectedCallback() {
      this.hideOverlay();
    }

    hideOverlay() {
      // let's hide the overlay
      // and revert the submit button
      const overlay = document.querySelector('.prepparing-diamonds__loading-wrapper');
      const msgEl = overlay.querySelector('.prepparing-diamonds__msg');
      if (msgEl) {
        msgEl.textContent = '';
      }
      if (overlay) {
        overlay.style.display = 'none';
      }
      //this.submitBtn.removeAttribute('disabled');
    }

    static async checkAndRedirect({ url, retries = 10, delay = 500, direct = true }) {
      for (let i = 0; i < retries; i++) {
        try {
          const response = await fetch(url, { method: 'HEAD' });
          if (response.ok) {
            // If the status is 200-299, proceed with redirect
            if (direct) window.location.href = url;
            return;
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }

        // Wait before retrying if not successful
        if (i < retries - 1) {
          await new Promise((resolve) => setTimeout(resolve, delay));
        }
      }

      console.error(`Failed to load the URL after ${retries} attempts.`);
    }

    // Handle page load from cache (bfcache)
    handlePageShow(event) {
      // Check if the page was loaded from the browser cache (bfcache)
      if (event.persisted) {
        this.hideOverlay();
      }
    }
  };

  window.customElements.define('diamond-actions', DiamondActions);
}
